const Select = ({label, name, value, onChange, autoComplete=name, required = true, disabled = false, children}) => {
    return (
        <>
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <select
                name={name}
                required={required ?? true}
                value={value}
                onChange={onChange}
                disabled={disabled}
                autoComplete={autoComplete}
                className="w-full border-gray-300 rounded-md disabled:cursor-not-allowed">
                {children}
            </select>
        </>
    )
}

export default Select